const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        "label": '점검일',
        "value": 'date',
        "query": {'ss': 'startDate', 'ee': 'endDate'},
        "options": {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-select-field',
        "label": '사업장명',
        "value": '사업장명',
        "query": {'f_id': 'fieldId', 'f_name': 'fieldName'},
        "options": {
          default: '',
        }
      },
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        // 사업장명은 위 선택형 필터로 조회한다. 키워드로 두면 '%포항%' 처럼
        // 선행 와일드카드가 붙어 meta 값 인덱스를 타지 못한다.
        "options": { hiddenList: ['사업장명', '점검시간', '작성일'] }
      }
    ]
  },

  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 점검일 범위 검색
    if (search.date) {
      conditions.push({ key: 'body.점검일', operator: '>=', value: search.date.startDate })
      conditions.push({ key: 'body.점검일', operator: '<',  value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : '' })
    }

    // 사업장명 (선택형) - 정확한 명칭이므로 '=' 로 조회한다. LIKE '%...%' 는
    // 선행 와일드카드 때문에 meta 값 인덱스를 쓰지 못해 전체 스캔이 된다.
    if (search.사업장명 && search.사업장명.fieldName) {
      conditions.push({ key: 'body.관리감독자정보.사업장명', operator: '=', value: search.사업장명.fieldName })
    }

    // 검색조건 (키워드)
    const heads = list.getHead().map(e => ({ [e.name]: e.key }));
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword && types[search.column.head]) {
      conditions.push({ key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%` })
    }

    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      { name: "사업장명",  key: "body.관리감독자정보.사업장명" },
      { name: "부서명",    key: "body.관리감독자정보.부서명" },
      { name: "직무",      key: "body.관리감독자정보.직무" },
      { name: "직급",      key: "body.관리감독자정보.직급" },
      { name: "이름",      key: "body.관리감독자정보.이름" },
      { name: "점검일",    key: "body.점검일" },
      { name: "점검시간",  key: "body.점검시간" },
      { name: "작성일",    key: "body.작성일" },
    ];
  },

  getCol: (index, value, func) => {
    try {
      const body = func.getContent(value);
      const info = body.관리감독자정보 || {};
      let i = 0;
      if (index === i++) return info.사업장명  || '';
      if (index === i++) return info.부서명    || '';
      if (index === i++) return info.직무      || '';
      if (index === i++) return info.직급      || '';
      if (index === i++) return info.이름      || '';
      if (index === i++) return body.점검일    || '';
      if (index === i++) return body.점검시간  || '';
      if (index === i++) return body.작성일    || '';
    } catch (e) {}
    return '';
  },

  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}

export default list;
